import React from 'react';
import { Trans } from '@lingui/react/macro';

import type { Locale } from '@rover/constants/src/i18n/lingui.constants';
import { Button, Flex } from '@rover/kibble/core';
import { getTrainerSearchPageUrl } from '@rover/react-lib/src/pages/training/utils/params';
import { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSlugEnum';
import { TrainingSearchQuery } from '@rover/rsdk/src/apiClient/latest/model/trainingSearchQuery';
import { TrainingSearchResponse } from '@rover/rsdk/src/apiClient/latest/model/trainingSearchResponse';

import TrainingSearchResultsCarousel from '../../../../components/TrainingSearchResultsCarousel';
import getCarouselAnalyticsHandlers from '../../../../utilities/getCarouselAnalyticsHandlers';
import { PageSectionId, useSectionRef } from '../../../hooks/useSectionRef';
import { SeoLocationPageProps } from '../../../types';

type Props = {
  searchResponse: TrainingSearchResponse;
  heading: string;
  providerNounPlural: string;
  searchFilters?: Partial<TrainingSearchQuery>;
  countryConfig: SeoLocationPageProps['countryConfig'];
  locale: Locale;
};

const { onPaginate, onSearchResultCardClick, onSearchResultCardViewed, onCtaPress } =
  getCarouselAnalyticsHandlers(ServiceTypeSlugEnum['dog-training']);

const TrainingSeoLocationResultsCarousel: React.FC<Props> = ({
  searchResponse,
  heading,
  // Aliased to reuse the translated "View more {sitterTypePlural}" message ID.
  providerNounPlural: sitterTypePlural,
  searchFilters = {},
  countryConfig,
  locale,
}: Props) => {
  const sectionRef = useSectionRef(PageSectionId.CarouselSearchResults, { threshold: 0.6 });

  return (
    <Flex htmlRef={sectionRef} gap="6x" flexDirection="column" alignItems="center">
      <TrainingSearchResultsCarousel
        searchResults={searchResponse.results}
        heading={heading}
        shouldUsePriceTransparency={searchResponse.shouldUsePriceTransparency}
        onPaginate={onPaginate}
        onSearchResultCardClick={onSearchResultCardClick}
        onSearchResultCardViewed={onSearchResultCardViewed}
        rootCarouselRef={sectionRef}
        countryConfig={countryConfig}
        locale={locale}
      />
      <Button
        width="100%"
        maxWidth={['335px']}
        href={getTrainerSearchPageUrl(searchFilters)}
        onPress={onCtaPress}
      >
        <Trans>View more {sitterTypePlural}</Trans>
      </Button>
    </Flex>
  );
};
export default TrainingSeoLocationResultsCarousel;
